module.exports = __webpack_public_path__ + "static/img/feature_2.b752c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/feature_2.png
// module id = 4UIV
// module chunks = 0